import React from "react";
import { SlipHeader } from "./AnnaTicketSlip";

// 72-80 mm thermal-roll versions of the Saree token and Protocol ticket (Print size: Thermal slip).
const box = { border: "1px solid #444", borderRadius: "5px", padding: "1.5mm 2mm", fontSize: "11px", lineHeight: 1.45 };
const img = { width: "22mm", height: "22mm", objectFit: "cover", border: "1px solid #444", borderRadius: "4px" };
const Line = ({ label, children }) => (children || children === 0 ? <p style={{ margin: 0 }}><b>{label}:</b> {children}</p> : null);

function Slip({ temple, title, copyLabel, number, photo, qr, children, note, testid }) {
  return (
    <div className="print-area bg-white text-black mx-auto" style={{ width: "72mm", padding: "3mm 2.5mm", fontFamily: "system-ui, sans-serif" }} data-testid={testid}>
      <SlipHeader temple={temple} />
      <p style={{ textAlign: "center", fontSize: "11.5px", fontWeight: 800, letterSpacing: "0.5px", margin: 0 }}>{title}</p>
      {copyLabel && <p style={{ textAlign: "center", margin: "1mm 0 0" }}><span style={{ fontSize: "9.5px", fontWeight: 800, letterSpacing: "1px", textTransform: "uppercase", border: "1px solid #000", borderRadius: "3px", padding: "0 6px" }}>{copyLabel}</span></p>}
      <div style={{ display: "flex", justifyContent: "center", gap: "4mm", margin: "2mm 0" }}>
        {photo ? <img src={photo} alt="" style={img} />
          : <div style={{ ...img, border: "1px dashed #888", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "8px" }}>NO PHOTO</div>}
        {qr && <img src={qr} alt="" style={{ ...img, objectFit: "contain", imageRendering: "pixelated" }} />}
      </div>
      <div style={box}>
        <p style={{ margin: "0 0 1mm", textAlign: "center" }}><span style={{ fontFamily: "monospace", fontWeight: 800, fontSize: "12px", letterSpacing: "-0.2px" }}>{number}</span></p>
        {children}
      </div>
      {note && <p style={{ borderTop: "1px dashed #999", marginTop: "1.5mm", paddingTop: "1mm", fontSize: "9.5px", lineHeight: 1.35 }}>{note}</p>}
      <p style={{ margin: "1mm 0 0", textAlign: "center", fontSize: "9px", fontStyle: "italic" }}>Designed &amp; Developed by <b>Aatreya Infotech Systems LLP</b></p>
    </div>
  );
}

export function SareeSlip({ token: t, temple, copyLabel }) {
  const dmy = (d) => (d ? `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}` : "");
  return (
    <Slip temple={temple} title="VASTRA PRASADAM" copyLabel={copyLabel} number={t.token_no} photo={t.photo} qr={t.qr_data_url} testid="saree-slip"
      note="Present this slip / QR at the Godown for verification. Non-transferable.">
      <Line label="Category">{t.category}</Line>
      <Line label="Name">{t.name}</Line>
      <Line label="Saree Type">{t.saree_type_name}</Line>
      <Line label="Rate">₹{t.rate}</Line>
      <Line label="Quantity">{t.quantity || 1}</Line>
      <Line label="Return Type">{t.return_type}</Line>
      <Line label="Booking Date">{dmy(t.booking_date)}</Line>
      <Line label="Phone">{t.phone}</Line>
      <Line label="Received">{t.created_at ? new Date(t.created_at).toLocaleString("en-IN") : ""}</Line>
    </Slip>
  );
}

export function ProtocolSlip({ txn, temple }) {
  const t = txn.ticket || {};
  return (
    <Slip temple={temple} title="PROTOCOL DARSHAN ACCESS TICKET" number={t.ticket_no} photo={txn.photo} qr={t.qr_data_url} testid="protocol-slip"
      note="Carry a valid photo ID. Non-transferable. Entry subject to verification at the temple entrance. Follow the temple dress code.">
      <Line label="Transaction">{txn.transaction_id}</Line>
      <Line label="Devotee">{txn.devotee_name}</Line>
      <Line label="Reference">{txn.reference_name}</Line>
      <Line label="Darshan">{txn.darshan_type_name}</Line>
      <Line label="Devotees">{txn.num_devotees}</Line>
      <Line label="Paid / Free">{txn.paid_free}{txn.paid_free !== "FREE" ? ` · ₹${txn.amount}` : ""}</Line>
      <Line label="Booking">{txn.booking_type === "ADVANCED" ? "Advanced" : "Current"}</Line>
      <Line label="Issued">{t.issued_at ? new Date(t.issued_at).toLocaleString("en-IN") : "-"}</Line>
      <Line label={txn.darshan_date ? "Darshan Date" : "Valid Date"}>
        {txn.darshan_date ? txn.darshan_date.split("-").reverse().join("/") : t.issued_at ? new Date(t.issued_at).toLocaleDateString("en-IN") : "-"}
      </Line>
    </Slip>
  );
}
